import { render, staticRenderFns } from "./Gonggaolist.vue?vue&type=template&id=6dec78ba&scoped=true"
import script from "./Gonggaolist.vue?vue&type=script&lang=js"
export * from "./Gonggaolist.vue?vue&type=script&lang=js"
import style0 from "./Gonggaolist.vue?vue&type=style&index=0&id=6dec78ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec78ba",
  null
  
)

export default component.exports